export class AzureDetailsModel {
    azureAdissuerUrl: string;
    azureAdinstance: string;
    azureAddomain: string;
    azureAdtenantId: string;
    azureAdclientId: string;
    azureAdclientSecret: string;
    azureADB2CExtensionAppClientId: string;
    azureAdcallbackPath: string;
}
